const CollapseContent = ({ children }) => children;
export default CollapseContent;
